import baseAxios from "axios";
import Session from "supertokens-auth-react/recipe/session";

Session.addAxiosInterceptors(baseAxios);

export const authAxios = baseAxios;
